import React from "react";
import FieldDescriptionCallout from "./FieldDescriptionCallout";

interface FieldWrapperProps {
  fieldId?: string;
  label?: string;
  description?: string;
  required?: boolean;
  error?: string;
  layout?: "default" | "checkbox";
  characterLimit?: number;
  currentCharacterCount?: number;
  children: React.ReactNode;
}

const FieldWrapper: React.FC<FieldWrapperProps> = ({
  fieldId,
  label,
  description,
  required,
  error,
  layout = "default",
  characterLimit,
  currentCharacterCount = 0,
  children,
}) => {
  const hasError = Boolean(error);
  const isAtLimit = characterLimit && currentCharacterCount >= characterLimit;

  if (layout === "checkbox") {
    return (
      <div className={`form-field ${hasError ? "form-field--error" : ""}`}>
        {label && (
          <label className="form-checkbox-row" htmlFor={fieldId}>
            {children}
            <span className="form-label">
              {label}
              {required && <span className="form-required-indicator"> *</span>}
            </span>
            {description && (
              <FieldDescriptionCallout description={description} />
            )}
          </label>
        )}
        {hasError && <div className="form-error">{error}</div>}
      </div>
    );
  }

  return (
    <div className={`form-field ${hasError ? "form-field--error" : ""}`}>
      {label && (
        <div className="form-label-row">
          <label className="form-label" htmlFor={fieldId}>
            {label}
            {required && <span className="form-required-indicator"> *</span>}
          </label>
          {description && <FieldDescriptionCallout description={description} />}
        </div>
      )}
      {children}
      {characterLimit && (
        <div className="form-character-counter-container">
          <span
            className={`form-character-counter ${
              isAtLimit ? "form-character-counter--at-limit" : ""
            }`}
          >
            {currentCharacterCount} / {characterLimit}
          </span>
          {isAtLimit && (
            <span className="form-character-limit-message">
              Character limit reached
            </span>
          )}
        </div>
      )}
      {hasError && <div className="form-error">{error}</div>}
    </div>
  );
};

export default FieldWrapper;
